import gql from 'graphql-tag';

export default gql`
mutation CreateFreeLease(
        $uuid: String!
        ) {
    createFreeLease(input:{
        uuidApp: $uuid
    }) {
        __typename
        uuids
        type
        created
        expires
        endpointsCompleted
        completed
    }
}
`;
